import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDocumentService } from "contexts/ServiceContext";
import { FileUri } from "api";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";
import { valueOr } from "util/statHelpers";

const mapApiDocumentFileUri = (fileUri: FileUri): DocumentsFile => {
  return {
    category: fileUri.Category,
    date: valueOr(fileUri.Date ? new Date(fileUri.Date) : undefined),
    filename: valueOr(fileUri.FileName),
    mimeType: valueOr(fileUri.Mime ?? "application/pdf"),
    url: fileUri.Uri ?? undefined,
  };
};

const useDocumentFiles = (
  cardCodes: string[]
): UseQueryResult<DocumentsFile[]> => {
  const documentService = useDocumentService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useQuery<DocumentsFile[]>({
    queryKey: ["contract-files", { contractNumber: cardCodes }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "Quotation/GetFileUriList/{DocEntry}",
      });
      return documentService
        .getDocumentFileList(cardCodes)
        .then((data) => data.value.map(mapApiDocumentFileUri))
        .catch((err) => {
          trackQueryError({ message: err.message }, eventId);
          throw err;
        });
    },
    enabled: cardCodes.length > 0,
  });
};

export default useDocumentFiles;
